module.exports = __webpack_public_path__ + "media/images/mobile/service/banner-6de1fc255e198311fdc0237a6d9e597f.jpg";